module.exports = __webpack_public_path__ + "img/service5.9b360c0f.png";